// 统计数据的数据转换
import { AI_GENERATOR_VIDEO_TAB_TYPE } from '../config/dataConfig/FJAIVideoGeneratorData.js';

const FJEaLogDataUtil = {
    getVideoGeneratorType: function (type) {
        const { AI_IMAGE_TO_VIDEO, AI_TEXT_TO_VIDEO, AI_EFFECTS_VIDEO } = AI_GENERATOR_VIDEO_TAB_TYPE;
        const tempInfo = {};
        tempInfo[AI_IMAGE_TO_VIDEO] = 'image to video';
        tempInfo[AI_TEXT_TO_VIDEO] = 'text to video';
        tempInfo[AI_EFFECTS_VIDEO] = 'video effect';
        return tempInfo[type];
    },
};

export default FJEaLogDataUtil;
